export const zipCodeRegex = /[a-zA-Z]\d[a-zA-Z]\s\d[a-zA-Z]\d/g;
export const phoneRegex = /^\(?([0-9]{3})\)?[-●]?([0-9]{3})[-●]?([0-9]{4})$/g;
export const numberRegex = /^[0-9]\d*(\.\d+)?$/g;
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/g;
export const emailRegexNoGlobal = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export default {
  zipCodeRegex,
};
